import LiveChart from '../../components/blocks/ui/LiveChart'
import { FaUsers } from "react-icons/fa";
import { RiUserStarFill } from "react-icons/ri";
import { FaBriefcase } from "react-icons/fa6";
import { BsPersonVcard } from "react-icons/bs";
import { FaThList } from "react-icons/fa";
import { useContext, useEffect, useState } from 'react';
import { HiOutlineClock } from "react-icons/hi";
import { AiOutlineClear } from "react-icons/ai";
import { DContext } from '../../context/Datacontext';
import { fetchSubmissionReport } from '../services/Dashboard/fetchSubmissionReport';
import { fetchClients } from '../services/managerApi/clientsApi';
// import { fetchManager } from '../services/fetchManager';
import { fetchAllUsers } from '../services/fetchGetUser';
import { fetchStatusReport } from '../services/Dashboard/fetchStatusReport';
import { useNavigate } from 'react-router-dom';
import { fetchCardsCount } from '../services/managerApi/fetchCardCount';
// import { CurrencyEuroIcon } from '@heroicons/react/24/outline';

function Dashboard() {
    const navigate = useNavigate();
    const [counts, setCounts] = useState({});

    const { BeURL, showAlert, currentUser } = useContext(DContext)

    const cards = [
        { key: 'userManagement', title: 'Users', icon: FaUsers, route: '/list-users', color: 'bg-green-100', bg: 'bg-green-300' },
        { key: 'clientManagement', title: 'Clients', icon: RiUserStarFill, route: '/list-clients', color: 'bg-blue-100', bg: 'bg-blue-300' },
        { key: 'JobManagement', title: 'Jobs', icon: FaBriefcase, route: '/list-jobs', color: 'bg-teal-100', bg: 'bg-teal-300' },
        { key: 'candidateManagement', title: 'Candidates', icon: BsPersonVcard, route: '/list-candidates', color: 'bg-purple-100', bg: 'bg-purple-300' },
        { key: 'status', title: 'Status', icon: FaThList, route: '/list-status', color: 'bg-slate-100', bg: 'bg-slate-300' }
    ]


    useEffect(() => {
        if (!currentUser || !BeURL) return;
        const companyId = currentUser?.company?.companyId;
        if (!companyId) {
            return;
        }
        fetchCardsCount(BeURL, showAlert, companyId, setCounts);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [BeURL, currentUser]);


    const [reportData, setReportData] = useState({
        submissions: {
            filter: "",
            fromDate: "",
            toDate: "",
            clientId: "",
            teamleadId: "",
            managerId: "",
            data: [
                {
                    "x-axis": [],
                    "y-axis": []
                }
            ],
            totalCount: 0
        },
        status: {
            filter: "",
            fromDate: "",
            toDate: "",
            clientId: "",
            teamleadId: "",
            managerId: "",
            data: [
                {
                    "x-axis": [],
                    "y-axis": []
                }
            ],
            totalCount: 0
        },
        profileActions: {
            filter: "",
            fromDate: "",
            toDate: "",
            clientId: "",
            teamleadId: "",
            managerId: "",
            data: [
                {
                    "x-axis": [],
                    "y-axis": []
                }
            ],
            totalCount: 0
        }
    })

    const filterOptions = [
        { label: "All", value: "all" },
        { label: "Today", value: "today" },
        { label: "Yesterday", value: "yesterday" },
        { label: "1W", value: "1w" },
        { label: "1M", value: "1m" },
        { label: "3M", value: "3m" },
        { label: "6M", value: "6m" },
        { label: "1Y", value: "1y" },
    ]


    const [teamleadsList, setTeamleadsList] = useState([]);
    const [managersList, setManagersList] = useState([]);
    const [clientsList, setClientsList] = useState([]);
    const [users, setUsers] = useState([]);
    const [dateFilterActive, setDateFilterActive] = useState({
        submissions: false, status: false
    })
    const [loading, setLoading] = useState({
        submissions: false, status: false
    })

    useEffect(() => {

        const fetchDatas = async () => {
            if (!currentUser?.company?.companyId) return;
            await fetchClients(BeURL, showAlert, setClientsList, currentUser?.company?.companyId)
            // fetchManager(currentUser?.company?.companyId, BeURL, showAlert, setManagersList)
            await fetchAllUsers(BeURL, showAlert, setUsers, currentUser?.company?.companyId)

        }
        fetchDatas()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser?.company?.companyId])

    useEffect(() => {
        if (!users.length > 0) return
        console.log("vbvvv")
        setTeamleadsList(users.filter(user => user.role === 'teamlead'))
        setManagersList(users.filter(user => user.role === 'manager'))

    }, [users])

    const controls = {
        show: true,
        download: true,
        selection: false,
        zoom: false,
        zoomin: true,
        zoomout: true,
        pan: true,
        reset: true,
        zoomEnabled: true,
        autoSelected: 'zoom'
    };

    // const timeStamps = [4, 6, 8, 9, 4, 3, 5]
    // const recruiters = ['nandhini', 'sandeep', 'recruiter 3', 'recruiter 4', 'recruiter 5', 'recruiter 6', 'recruiter 7']

    // const submissions = [
    //     { "x-axis": recruiters || [], "y-axis": timeStamps || [], color: "", seriesName: 'r 1' }
    // ]

    const handleFetchSubmissionReport = (key) => {

        if (key !== 'submissions' && key !== 'status') return;


        const submissionData = reportData.submissions
        let filters = {
            clientId: submissionData.clientId || "",
            teamLeadId: submissionData.teamleadId || "all",
            duration: submissionData.filter || "",
        }

        if (submissionData.filter === '') {
            filters['fromDate'] = submissionData.fromDate || ""
            filters['toDate'] = submissionData.toDate || ""
        }

        if (submissionData.managerId && submissionData.managerId.length > 0) {
            filters["managerId"] = submissionData.managerId
        }

        const statusData = reportData.status
        const statusFilters = {
            clientId: statusData.clientId,
            teamLeadId: statusData.teamleadId || "all",
            duration: statusData.filter || "",
        }
        if (statusData.filter === '') {
            statusFilters['fromDate'] = statusData.fromDate || ""
            statusFilters['toDate'] = statusData.toDate || ""
        }
        if (statusData.managerId && statusData.managerId.length > 0) {
            statusFilters["managerId"] = statusData.managerId
        }


        if (key === 'submissions') {
            console.log("Works 1")
            fetchSubmissionReport(BeURL, showAlert, filters, setReportData, setLoading, 'submissions')

        }
        else {
            fetchStatusReport(BeURL, showAlert, statusFilters, setReportData, setLoading, 'status')
        }

    }


    useEffect(() => {
        console.log("works")
        if (dateFilterActive.submissions) return;

        if (BeURL && reportData.submissions) {
            handleFetchSubmissionReport('submissions')
        }


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reportData.submissions.filter, reportData.submissions.clientId, reportData.submissions.managerId, reportData.submissions.teamleadId,
    dateFilterActive.submissions])




    useEffect(() => {
        console.log("works")
        if (dateFilterActive.status) return;

        if (BeURL && reportData.status) {
            handleFetchSubmissionReport('status')
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reportData.status.filter, reportData.status.clientId, reportData.status.managerId, reportData.status.teamleadId,
    dateFilterActive.status])


    // eslint-disable-next-line react-hooks/exhaustive-deps


    // useEffect(() => {

    //     setInterval(() => {
    //         console.log("Auto refreshing dashboard data...")
    //         handleFetchSubmissionReport('submissions')
    //         handleFetchSubmissionReport('status')
    //         const companyId = currentUser?.company?.companyId
    //         fetchCardsCount(BeURL, showAlert, companyId, setCounts)
    //     }, 5000);
    // }, [])


    console.log("reportData:", reportData.submissions, reportData.status)

    // const isChartData = ((!reportData.submissions?.data.length && !reportData.submissions.data[0]?.["x-axis"]?.length) ||
    //     (!reportData.status?.data.length && !reportData.status.data[0]?.["x-axis"]?.length))

    // console.log("isChartData", isChartData)

    const renderReportHeader = (data, heading) => {
        return (
            <div className='bg-white/80 backdrop-blur-sm border border-slate-200/60 rounded-xl shadow-md mb-4 overflow-x-auto hover:shadow-lg transition-shadow duration-300'>
                <div className='flex items-center gap-2 sm:gap-3 p-3 sm:p-4 min-w-max flex-wrap lg:flex-nowrap'>

                    {/* Time Filter */}
                    <div className='flex items-center gap-2 px-3 py-2 border  rounded-lg  focus-within:border-primary-400 focus-within:ring-[1px] focus-within:ring-primary-100 transition-all duration-200 group'>
                        <HiOutlineClock className='text-primary-600 text-base group-hover:scale-110 transition-transform' />
                        <select
                            value={reportData[data].filter}
                            onChange={e => setReportData({ ...reportData, [data]: { ...reportData[data], filter: e.target.value, fromDate: "", toDate: "" } })}
                            className='text-sm outline-none cursor-pointer bg-transparent border-none pr-1 text-slate-700 font-medium'
                        >
                            <option value={""}>Select Duration</option>
                            {
                                filterOptions.map((opt, i) => (
                                    <option value={opt.value} key={i}>{opt.label}</option>
                                ))
                            }
                        </select>
                    </div>

                    {/* Divider */}
                    <div className='h-6 w-px bg-gradient-to-b from-transparent via-slate-300 to-transparent hidden sm:block'></div>

                    {/* Date Range */}
                    <div className='flex items-center gap-2 px-3 py-2 bg-slate-50 rounded-lg border border-slate-200 hover:border-slate-300 transition-colors'>
                        <label className='text-xs font-medium text-slate-600' htmlFor={`fromDate-${data}`}>From</label>
                        <input
                            id={`fromDate-${data}`}
                            type="date"
                            value={reportData[data].fromDate}
                            max={reportData[data].toDate || undefined}
                            onChange={e => {
                                setReportData({ ...reportData, [data]: { ...reportData[data], fromDate: e.target.value, filter: "" } })
                                setDateFilterActive(prev => ({
                                    ...prev,
                                    [data]: true
                                }))
                            }}
                            className='text-xs px-2 py-1.5 border border-slate-300 rounded-md outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 w-[130px] bg-white transition-all'
                        />
                        <span className='text-slate-400 text-xs font-bold'>→</span>
                        <label className='text-xs font-medium text-slate-600' htmlFor={`toDate-${data}`}>To</label>
                        <input
                            id={`toDate-${data}`}
                            type="date"
                            value={reportData[data].toDate}
                            min={reportData[data].fromDate || undefined}
                            onChange={e => {
                                setReportData({ ...reportData, [data]: { ...reportData[data], toDate: e.target.value, filter: "" } })
                                setDateFilterActive(prev => ({
                                    ...prev,
                                    [data]: true
                                }))
                            }}
                            className='text-xs px-2 py-1.5 border border-slate-300 rounded-md outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 w-[130px] bg-white transition-all'
                        />

                        <div>
                            <button className='flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white rounded-lg text-xs font-semibold shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 active:scale-95'
                                title='filters dates' onClick={() => setDateFilterActive(prev => ({
                                    ...prev,
                                    [data]: false
                                }))}>Filter</button>
                        </div>
                    </div>

                    {
                        clientsList.length > 0 && (
                            <>
                                {/* Divider */}
                                <div className='h-6 w-px bg-gradient-to-b from-transparent via-slate-300 to-transparent hidden sm:block'></div>

                                {/* Client Filter */}
                                <div className='flex items-center gap-2 px-3 py-2 bg-blue-50/50 border border-blue-200 rounded-lg hover:border-blue-300 focus-within:border-blue-400 focus-within:ring-2 focus-within:ring-blue-100 transition-all'>
                                    <label className='text-xs font-medium text-slate-600 whitespace-nowrap'>Client</label>
                                    <select
                                        value={reportData[data].clientId}
                                        onChange={e => setReportData({ ...reportData, [data]: { ...reportData[data], clientId: e.target.value } })}
                                        className='text-xs outline-none cursor-pointer bg-transparent border-none text-slate-700 font-medium min-w-[100px]'
                                    >
                                        <option value={""}>All</option>
                                        {
                                            clientsList.length ?
                                                clientsList.map((client, i) => (
                                                    <option value={client._id} key={i}>{client.clientName}</option>
                                                ))
                                                :
                                                <option disabled>No clients found</option>
                                        }
                                    </select>
                                </div>
                            </>
                        )
                    }

                    {
                        managersList.length > 0 && (
                            <>
                                {/* Divider */}
                                <div className='h-6 w-px bg-gradient-to-b from-transparent via-slate-300 to-transparent hidden sm:block'></div>

                                {/* Manager Filter */}
                                <div className='flex items-center gap-2 px-3 py-2 bg-orange-50/50 border border-orange-200 rounded-lg hover:border-orange-300 focus-within:border-orange-400 focus-within:ring-2 focus-within:ring-orange-100 transition-all'>
                                    <label className='text-xs font-medium text-slate-600 whitespace-nowrap'>Manager</label>
                                    <select
                                        value={reportData[data].managerId}
                                        onChange={e => setReportData({ ...reportData, [data]: { ...reportData[data], managerId: e.target.value, teamleadId: "" } })}
                                        className='text-xs outline-none cursor-pointer bg-transparent border-none text-slate-700 font-medium min-w-[100px]'
                                    >
                                        <option value={""}>All</option>
                                        {
                                            managersList.length ?
                                                managersList.map((manager, i) => (
                                                    <option value={manager._id} key={i}>{manager.fullName}</option>
                                                ))
                                                :
                                                <option disabled>No managers found</option>
                                        }
                                    </select>
                                </div>
                            </>
                        )
                    }

                    {
                        teamleadsList.length > 0 && (
                            <>
                                {/* Divider */}
                                <div className='h-6 w-px bg-gradient-to-b from-transparent via-slate-300 to-transparent hidden sm:block'></div>

                                {/* Teamlead Filter */}
                                <div className='flex items-center gap-2 px-3 py-2 bg-purple-50/50 border border-purple-200 rounded-lg hover:border-purple-300 focus-within:border-purple-400 focus-within:ring-2 focus-within:ring-purple-100 transition-all'>
                                    <label className='text-xs font-medium text-slate-600 whitespace-nowrap'>Teamlead</label>
                                    <select
                                        value={reportData[data].teamleadId}
                                        onChange={e => setReportData({ ...reportData, [data]: { ...reportData[data], teamleadId: e.target.value, managerId: "" } })}
                                        className='text-xs outline-none cursor-pointer bg-transparent border-none text-slate-700 font-medium min-w-[100px]'
                                    >
                                        <option value={""}>All</option>
                                        {
                                            teamleadsList.length ?
                                                teamleadsList.map((teamlead, i) => (
                                                    <option value={teamlead._id} key={i} className={`${teamlead.isEmployee === false && 'bg-red-500'}`}>{teamlead.fullName}</option>
                                                ))
                                                :
                                                <option disabled>No teamleads found</option>
                                        }
                                    </select>
                                </div>
                            </>
                        )
                    }


                    {/* Divider */}
                    <div className='h-6 w-px bg-gradient-to-b from-transparent via-slate-300 to-transparent hidden sm:block'></div>

                    {/* Clear button */}
                    <button
                        onClick={() => {
                            setReportData({ ...reportData, [data]: { filter: "all", fromDate: "", toDate: "", clientId: "", teamleadId: "", data: [], managerId: "" } })
                            setDateFilterActive(false)
                        }}
                        className='flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-lg text-xs font-semibold shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 active:scale-95'
                        title='Clear all filters'
                    >
                        <AiOutlineClear className='text-base' />
                        <span>Clear</span>
                    </button>

                </div>
            </div>
        )
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-primary-50/20 p-4 sm:p-6 lg:p-8">

            {/* Header Section */}
            <div className="mb-8">
                <h1 className='text-3xl sm:text-4xl font-bold text-slate-800 mb-2 bg-gradient-to-r from-primary-600 to-blue-600 bg-clip-text text-transparent'>
                    Dashboard
                </h1>
                <p className="text-slate-600 text-sm sm:text-base">Welcome back! Here's what's happening today.</p>
            </div>

            {/* Stats Cards Grid */}
            <div className='mb-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 sm:gap-6'>
                {
                    cards.length ?
                        cards.map((card, i) => (
                            <div
                                key={card.key}
                                onClick={() => navigate(card.route)}
                                className={`group relative p-6 rounded-3xl bg-gradient-to-br from-white to-slate-50/50 border-2 border-slate-200/60 shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer overflow-hidden transform hover:-translate-y-2 hover:scale-[1.02]`}
                            >
                                {/* Animated Border Glow */}
                                <div className={`absolute inset-0 rounded-3xl bg-gradient-to-br ${card.bg.replace('bg-', 'from-')} ${card.bg.replace('bg-', 'to-').replace('-300', '-500')} opacity-0 group-hover:opacity-20 blur-xl transition-opacity duration-500`}></div>

                                {/* Top Accent Line */}
                                <div className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r ${card.bg.replace('bg-', 'from-').replace('-300', '-400')} ${card.bg.replace('bg-', 'to-').replace('-300', '-600')} rounded-t-3xl transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left`}></div>

                                {/* Background Pattern */}
                                <div className={`absolute inset-0 bg-gradient-to-br ${card.color} opacity-0 group-hover:opacity-30 transition-all duration-500`}>
                                    <div className="absolute inset-0" style={{
                                        backgroundImage: `radial-gradient(circle at 2px 2px, rgba(255,255,255,0.15) 1px, transparent 0)`,
                                        backgroundSize: '32px 32px'
                                    }}></div>
                                </div>

                                {/* Content */}
                                <div className="relative z-10">
                                    {/* Icon Container with Floating Animation */}
                                    <div className="relative mb-5">
                                        <div className={`${card.bg} bg-opacity-15 w-16 h-16 sm:w-20 sm:h-20 rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl backdrop-blur-sm border-2 ${card.bg.replace('bg-', 'border-').replace('-300', '-200')} group-hover:rotate-[360deg] group-hover:scale-110 transition-all duration-700`}>
                                            <card.icon className={`text-3xl sm:text-4xl ${card.bg.replace('bg-', 'text-').replace('-300', '-600')} group-hover:scale-110 transition-transform duration-500`} />
                                        </div>
                                        {/* Icon Glow Effect */}
                                        <div className={`absolute inset-0 ${card.bg} opacity-0 group-hover:opacity-40 blur-2xl rounded-full transition-opacity duration-500`}></div>
                                    </div>

                                    {/* Title with Gradient */}
                                    <h3 className="font-bold text-slate-500 text-xs sm:text-sm mb-3 uppercase tracking-wider group-hover:text-slate-700 transition-colors duration-300 leading-tight">
                                        Total {card.title}
                                    </h3>

                                    {/* Count with Enhanced Styling */}
                                    <div className="flex items-baseline gap-2">
                                        <p className={`text-4xl sm:text-5xl font-extrabold bg-gradient-to-br from-slate-800 to-slate-600 bg-clip-text text-transparent group-hover:from-${card.bg.replace('bg-', '').replace('-300', '-600')} group-hover:to-${card.bg.replace('bg-', '').replace('-300', '-800')} transition-all duration-500`}>
                                            {counts[card.key] ?? '--'}
                                            {/* {card?.title === 'Candidates' || card.key === 'total_candidate'
                                                ? 314442
                                                : (counts[card.key] ?? '--')
                                            } */}

                                        </p>
                                        {/* Trend Indicator (Optional Visual Enhancement) */}
                                        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                                            <svg className={`w-5 h-5 ${card.bg.replace('bg-', 'text-').replace('-300', '-500')}`} fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" />
                                            </svg>
                                        </div>
                                    </div>

                                    {/* Subtitle Badge */}
                                    <div className={`mt-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full ${card.color} ${card.bg.replace('bg-', 'border-').replace('-300', '-200')} border opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-2 group-hover:translate-y-0`}>
                                        <div className={`w-1.5 h-1.5 rounded-full ${card.bg} animate-pulse`}></div>
                                        <span className="text-xs font-semibold text-slate-700">View Details</span>
                                    </div>
                                </div>

                                {/* Decorative Floating Circles */}
                                <div className="absolute -right-8 -top-8 w-32 h-32 bg-gradient-to-br from-primary-300/20 to-transparent rounded-full blur-3xl group-hover:scale-150 group-hover:rotate-90 transition-all duration-700"></div>
                                <div className="absolute -left-8 -bottom-8 w-28 h-28 bg-gradient-to-tr from-blue-300/20 to-transparent rounded-full blur-3xl group-hover:scale-150 group-hover:-rotate-90 transition-all duration-700"></div>

                                {/* Shine Effect on Hover */}
                                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-1000">
                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                                </div>
                            </div>
                        ))
                        :
                        <div className="col-span-full text-center py-16 bg-gradient-to-br from-white to-slate-50 rounded-3xl border-2 border-dashed border-slate-300 shadow-lg">
                            <div className="text-slate-400 text-5xl mb-4">📊</div>
                            <p className="text-slate-600 font-medium text-lg">No card data available!</p>
                            <p className="text-slate-400 text-sm mt-2">Data will appear here once loaded</p>
                        </div>
                }
            </div>


            {/* Reports Section */}
            {
                [{ title: "Submission Report", key: "submissions" }, { title: "Status Report", key: "status" }].map((report, idx) => (
                    <div className='mb-10' key={idx}>

                        {/* Report Header Card */}
                        <div className='bg-white rounded-xl shadow-md border border-slate-200/60 p-5 mb-4'>
                            <div className='flex flex-col sm:flex-row sm:items-center justify-between gap-3'>
                                <div className='flex items-center gap-3'>
                                    <div className={`w-12 h-12 rounded-lg bg-gradient-to-br ${idx === 0 ? 'from-primary-400 to-primary-600' : 'from-blue-400 to-blue-600'} flex items-center justify-center shadow-lg`}>
                                        <FaThList className='text-white text-xl' />
                                    </div>
                                    <div>
                                        <h3 className='text-xl sm:text-2xl font-bold text-slate-800'>{report.title}</h3>
                                        <p className='text-xs text-slate-500 mt-0.5'>Analysis and insights</p>
                                    </div>
                                </div>

                                {/* Total Count Badge */}
                                <div className={`px-5 py-2.5 rounded-xl bg-gradient-to-br from-blue-50 to-blue-100 border ${idx === 0 ? 'border-primary-200' : 'border-blue-200'} shadow-sm`}>
                                    <span className='text-xs font-semibold text-slate-600 block mb-1'>
                                        Total {report.key === "submissions" ? "Submissions" : "Status"}
                                    </span>
                                    <span className={`text-2xl font-bold bg-gradient-to-r from-blue-600 to-blue-700 bg-clip-text text-transparent`}>
                                        {(currentUser.role === 'manager' && reportData[report.key].teamleadId === '')
                                            ? reportData[report.key]?.data?.[0]?.["y-axis"]?.reduce((a, b) => a + b, 0)
                                            : reportData[report.key].totalCount}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Filters */}
                        {renderReportHeader(report.key)}

                        {/* Chart Container */}
                        <div className='bg-white rounded-xl shadow-md border border-slate-200/60 p-4 sm:p-6 hover:shadow-lg transition-shadow duration-300'>
                            <div className='h-[400px] sm:h-[450px]'>
                                {loading[report.key] ? <div className="animate-pulse space-y-3">
                                    <div className="p-4 bg-white rounded-xl shadow w-full">

                                        {/* Title */}
                                        <div className="h-4 w-32 bg-slate-200 rounded mb-4 animate-pulse"></div>

                                        {/* Chart */}
                                        <div className="h-96 flex items-end gap-3">
                                            {[40, 70, 50, 90, 60, 30, 80].map((h, i) => (
                                                <div key={i} className="flex flex-col items-center flex-1 gap-2 h-full">

                                                    {/* give this container height */}
                                                    <div className="flex items-end w-full h-full">
                                                        <div
                                                            className="w-12 bg-slate-200 rounded-md animate-pulse"
                                                            style={{ height: `${h}%` }}
                                                        />
                                                    </div>

                                                    {/* label */}
                                                    {/* <div className="h-3 w-6 bg-slate-200 rounded animate-pulse"></div> */}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div> : reportData[report.key]?.data?.length && <LiveChart
                                    data={reportData[report.key].data || []}
                                    title={report.title || ""}
                                    barWidth="40%"
                                    barOrientation="vertical"
                                    controls={controls}
                                />}
                            </div>
                        </div>
                    </div>
                ))
            }

            {/* <div className='h-[450px] my-4'>
                <h3 className='text-xl font-medium my-2'>Submission Report</h3>
                {renderReportHeader("submissions")}
                <LiveChart data={reportData["submissions"].data || []} title={"Submission Report" || ""} barWidth="40%" barOrientation="vertical" controls={controls} />
            </div>

            <div className='h-[450px] my-4'>
                <h3 className='text-xl font-medium my-2'>Status Report</h3>
                {renderReportHeader("status")}
                <LiveChart data={reportData["status"].data || []} title={"Status Report" || ""} barWidth="40%" barOrientation="vertical" controls={controls} />
            </div> */}


        </div>
    )
}

export default Dashboard